// Make sure to prefix the mutation names with the module to avoid collisions
// export const UNION_SET_ROLES = "unionSetRoles";

export const UNION_GET_SHARES_WITH = 'unionGetSharesWith'
export const ORGANIZATION_GET_MEMBERSHIP_TITLES = 'organizationGetMembershipTitles'
export const ORGANIZATION_GET_ACCESS_REQUEST_FIELDS = 'organizationGetAccessRequestFields'

export const OPEN_ACT_AS_MEMBERSHIP_GROUPS_MODAL = 'openActAsMembershipGroupsModal'
export const CLOSE_ACT_AS_MEMBERSHIP_GROUPS_MODAL = 'closeActAsMembershipGroupsModal'